module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-join-menu')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e03cdd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/UpJoinMenu.vue
// module id = 2317
// module chunks = 1